import type { AxiosError } from "axios";
import { CONFIG } from "../../config";
import { IPartnerDeal } from "../../interfaces/partnerDeal.interface";
import { IQueryFilters } from "../../interfaces/queryFilters.interface";
import { getTokenizedAxios } from "../../utils/axiosWithTokenGen";

export async function getPartnerDealsFromServer(
  params: IQueryFilters<IPartnerDeal>
): Promise<{
  data: IPartnerDeal[];
  totalCount: number;
  currentCount: number;
}> {
  const axios = await getTokenizedAxios();
  const path = "/partnerDeals/";

  return axios
    .get(CONFIG.ADMIN_SERVER.BASE_URL + path, { params })
    .then((data) => data?.data);
}

export async function createPartnerDealsServer(
  partnerDeals: Partial<IPartnerDeal>[]
): Promise<{ partnerDeals: IPartnerDeal[] }> {
  const axios = await getTokenizedAxios();
  const path = "/partnerDeals/create";

  try {
    return await axios
      .post(CONFIG.ADMIN_SERVER.BASE_URL + path, { partnerDeals })
      .then((data) => data?.data);
  } catch (error) {
    throw new Error(
      getPartnerDealErrorMessage(error, "Could not create merchant deal.")
    );
  }
}

export async function validatePartnerDealRegistrationNumberServer(
  businessRegistrationNumber: string
): Promise<void> {
  const axios = await getTokenizedAxios();
  const path = "/partnerDeals/";

  try {
    const response = await axios
      .get(CONFIG.ADMIN_SERVER.BASE_URL + path, {
        params: {
          businessRegistrationNumber,
          validateRegistrationNumber: true,
        },
      })
      .then((data) => data?.data);
    if (response?.available !== true) {
      throw new Error("Could not validate this KVK number. Please try again.");
    }
  } catch (error) {
    throw new Error(
      getPartnerDealErrorMessage(
        error,
        "Could not validate this KVK number. Please try again."
      )
    );
  }
}

function getPartnerDealErrorMessage(error: unknown, fallback: string): string {
  const axiosMessage = (error as AxiosError<{ message?: string }>)?.response
    ?.data?.message;
  const directMessage = (error as { message?: string })?.message;
  const message = (axiosMessage || directMessage || fallback).replace(
    /^Oops,\s*/i,
    ""
  );
  return message.charAt(0).toUpperCase() + message.slice(1);
}
// export async function editPartnerServer({
//   partnerId,
//   update,
// }: {
//   partnerId: string;
//   update: Partial<IPartner>;
// }): Promise<{ partner: IPartner }> {
//   const axios = await getTokenizedAxios();
//   const path = "/partners/";

//   return axios
//     .put(CONFIG.ADMIN_SERVER.BASE_URL + path + partnerId, update)
//     .then((data) => data.data);
// }
export async function deletePartnerDealServer({
  partnerDealId,
}: {
  partnerDealId: string;
}): Promise<IPartnerDeal> {
  const axios = await getTokenizedAxios();
  const path = "/partnerDeals/";

  return axios
    .delete(CONFIG.ADMIN_SERVER.BASE_URL + path + partnerDealId)
    .then((data) => data?.data);
}
